import {MUTATION_KEYS} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {httpVerifyInviteToken} from './auth.http'

type UseVerifyInviteToken = {
    onSuccess?: () => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useVerifyInviteToken = (options?: UseVerifyInviteToken) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.VERIFY_RECOVERY_TOKEN],
        mutationFn: httpVerifyInviteToken,
        onError: (error: AxiosError<ErrorResponseData>) => options?.onError?.(error),
        onSuccess: () => options?.onSuccess?.()
    })
